import { DesignTemplate } from "@/api/config/chalice-types";
import { Divider } from "antd";
import { UseStateReturn } from "fixtures/globalConstants";
import { useState } from "react";
import { Post } from "store/posts/postConstants";
import PostCaptionEditor from "./Caption/PostCaptionEditor";
import MediaThumbnailList from "./Media/MediaThumbnailList";
import PublishedPostDetail from "./PublishedPostDetail";

type PostEditorContentProps = {
  post?: Post;
  openDesignEditor: () => void;
  templateState: UseStateReturn<DesignTemplate | undefined>;
  captionState: UseStateReturn<string>;
  mediaUrlsState: UseStateReturn<string[]>;
  onRefetchNeeded: () => void;
};

const PostEditorContent = ({
  post,
  captionState,
  mediaUrlsState,
  templateState,
  openDesignEditor,
  onRefetchNeeded,
}: PostEditorContentProps) => {
  const [isGeneratePanelOpen, setIsGeneratePanelOpen] = useState(false);

  return (
    <>
      {/* {caption.length === 0 && ( */}
      {/* <Button
        type="link"
        className="!p-0 !h-auto self-start mb-2"
        onClick={handleOpenGeneratePanel}
      >
        Generate Content
      </Button> */}
      {/* )} */}
      <div className="md:pr-6 border border-solid border-antd-colorBorder p-4 rounded flex flex-col">
        {post?.status === "PUBLISHED" ? (
          <PublishedPostDetail post={post as Post} />
        ) : (
          <>
            <PostCaptionEditor captionState={captionState} />
            <Divider />
            <MediaThumbnailList
              mediaUrlsState={mediaUrlsState}
              templateState={templateState}
              openDesignEditor={openDesignEditor}
            />
          </>
        )}
        {/* {isGeneratePanelOpen && (
          <SinglePostGeneratePanel
            open={isGeneratePanelOpen}
            onCancel={handleCloseGeneratePanel}
            initialMediaUrls={mediaUrls}
            initialCaption={caption}
            onSubmit={handleCloseGeneratePanel}
            onRefetchNeeded={onRefetchNeeded}
          />
        )} */}
      </div>
    </>
  );
};

export default PostEditorContent;
